import React from 'react';
import { Tooltip as ReactToolTip } from 'react-tooltip';
import Styles from './custom-text-styles.scss';
const WordReplacer = ({ input, wordsToReplace, className, definitions }) => {
    const usedKeywords = [];
    const replaceWords = (text) => {
        const wordsRegex = new RegExp(`\\b(${wordsToReplace.join('|')})\\b`, 'gi');
        const words = text.split(wordsRegex);
        return words.map((word, index) => {
            if (wordsToReplace.includes(word)) {
                usedKeywords.push(word);
                return {
                    word,
                    definition: definitions === null || definitions === void 0 ? void 0 : definitions[wordsToReplace.indexOf(word)]
                };
            }
            return { word };
        });
    };
    const highlightedText = replaceWords(input)
        .map((word, index, array) => {
        var _a;
        if (word.definition) {
            return `<span class="${className}" data-tooltip-id="${(_a = word.word) === null || _a === void 0 ? void 0 : _a.toLowerCase()}" data-tooltip-content="${word.definition.replace(/<[^>]+>/g, '')}">${word.word}</span>`;
        }
        return word.word;
    })
        .join('');
    return (React.createElement(React.Fragment, null,
        input && React.createElement("div", { dangerouslySetInnerHTML: { __html: highlightedText } }),
        usedKeywords.map((word, index) => (React.createElement(ReactToolTip, { key: `Tooltip-${index}-${word === null || word === void 0 ? void 0 : word.toLowerCase()}`, openOnClick: true, id: word === null || word === void 0 ? void 0 : word.toLowerCase(), className: Styles.strongDescription, style: {
                backgroundColor: '#fff06d',
                color: '#000',
                position: 'absolute',
                top: '1.5625rem',
                left: 0,
                right: 0,
                width: '25rem',
                maxWidth: '25rem',
                overflow: 'hidden',
                padding: '1rem',
                gap: '1.5rem',
                zIndex: 20000,
                borderRadius: '1rem',
                opacity: 1
            } })))));
};
export default WordReplacer;
